<div class="header">
  <div class="head-right">
    <span class="head-right__thai">ระบบเรียกดูข้อมูลการจ่ายชำระเงินให้แก่ผู้ขาย</span>
    <span class="head-right__eng">(Web Vendors)</span>
  </div>
</div>
